import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './payment-method.types';
import * as constants from './payment-method.constants';

export const paymentMethodReducer = generateResourceReducer<types.IPaymentMethod>({
  STORE: constants.STORE_PAYMENT_METHOD,
  CLEAR: constants.CLEAR_PAYMENT_METHOD,
});
